<template>
    <div>
        <v-dialog @input="close" :value="edit && edit.show" :width="dialogWidth">
            <v-card class="my-shadow" v-if="edit">
                <v-card-title>Click on a color to select it <v-spacer></v-spacer> <v-btn @click="edit = null" icon small absolute right><v-icon>mdi-close</v-icon></v-btn> </v-card-title>
                <v-card-text class="mt-5">
                    <div v-if="!group">
                        <my-form ref="attribute_form">
                            <div class="row">
                                <color-chip :color_info="variant.color_info" @click="selectColor(variant)" dark :color="(selectedColor && selectedColor.color == variant.color)? 'secondary' : 'grey'" class="ma-1" v-for="variant in $product.smakeVariants">{{variant.color}}</color-chip>
                                <!--<v-chip @click="selectColor(variant)" dark :color="(selectedColor && selectedColor.color == variant.color)? 'secondary' : 'grey'" class="ma-1" v-for="variant in $product.smakeVariants">{{variant.color}}</v-chip>-->
                            </div>
                            <div class="row">
                                <v-card-title v-if="!edit.id" class="col-12">All sizes are on by default. Click to&nbsp;<span style="text-decoration: underline;">deselect</span>&nbsp;a size</v-card-title>
                                <v-card-title v-else class="col-12">Click to&nbsp;<span style="text-decoration: underline;">deselect</span>&nbsp;a size</v-card-title>
                                <span class="col-12" v-if="selectedColor == null" >First select color, then size.</span>
                                <div class="col-12" v-if="selectedColor">
                                    <v-chip :color="(edit.attributes.find(x => x.name == 'Size' && x.value == size))? 'secondary' : 'grey'" dark @click="selectSize(size)" class="ma-1" v-for="size in selectedColor.sizes">{{$t(size)}}</v-chip>
                                </div>
                            </div>
                            <v-text-field v-model="edit.price" label="price"></v-text-field>
                            <v-text-field v-model="edit.sku" label="SKU" :rules="[validationRules.required]"></v-text-field>
                            <media-picker :multiple="true" v-model="edit.photos" label="Photo" :show_elements="true"></media-picker>
                            <v-btn @click="addAttribute()" outlined color="grey"><v-icon class="mr-2">mdi-plus</v-icon>Add custom attribute</v-btn>
                            <div v-for="(attribute,index) in edit.attributes" v-if="attribute.custom" class="mb-4">
                                <v-text-field label="Attribute name" v-model="attribute.name" :rules="[validationRules.required]"></v-text-field>
                                <v-select v-model="attribute.type" label="Select type" :items="types" :rules="[validationRules.required]" item-text="name" item-value="type"></v-select>
                                <v-text-field label="Attribute value" v-model="attribute.value" :rules="[validationRules.required]"></v-text-field>
                                <v-btn color="red" dark @click="edit.attributes.splice(index,1)">Usuń</v-btn>
                            </div>
                        </my-form>
                    </div>
                    <div v-else>
                        <my-form ref="attribute_form">
                            <div class="row">
                                <div v-for="variant in $product.smakeVariants">
                                    <v-chip
                                        @click="toggle('colors', variant.color)"
                                        outlined
                                        :color="(array.colors && array.colors.find(x => x == variant.color))? 'secondary' : 'gray'"
                                        class="ma-1"
                                    >
                                        <v-avatar>
                                            <v-img v-if="variant.image" :src="$root.getSrc(variant.image)" contain></v-img>
                                        </v-avatar>
                                        &nbsp;{{variant.color}}
                                    </v-chip>
                                </div>
                                <!--<color-chip @click="toggle('colors', variant.color)" dark :selected="array.colors && array.colors.find(x => x == variant.color)" :color_info="variant.color_info" class="ma-1" v-for="variant in $product.smakeVariants">{{variant.color}}</color-chip>-->
                            </div>
                            <div class="row">
                                <v-card-title v-if="!edit.id" class="col-12">All sizes are on by default. Click to&nbsp;<span style="text-decoration: underline;">deselect</span>&nbsp;a size</v-card-title>
                                <v-card-title v-else class="col-12">Click to&nbsp;<span style="text-decoration: underline;">deselect</span>&nbsp;a size</v-card-title>
                                <v-chip :color="(array.sizes.find(x => x == size))? 'secondary' : 'grey'" dark @click="toggle('sizes', size)" class="ma-1" v-for="size in availableSizes">{{$t(size)}}</v-chip>
                            </div>
                        </my-form>
                    </div>
                    <v-alert type="error" v-for="e in errors">{{e}}</v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
<!--                    <v-btn color="primary" outlined dark @click="edit = null">Close</v-btn>-->
                    <v-btn class="small-btns" color="secondary"  style="border: 2px solid #00034a;" dark @click="(!group)? save() : saveGroup()">Continue</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {getAttributes} from "../../api/products";
    import {getColorByName} from "../../helpers";
    import Vue from 'vue';
    export default {
        data:() => {
            return{
                array:{
                    sizes:[],
                    colors:[]
                },
                edit:null,
                types:[{
                    name:'Text',
                    type:'text'
                },{
                    name:'Color',
                    type:'color',
                },{
                    name: 'True or false',
                    type: 'bool'
                }],
                group:false,
                selectedColor:null,
                resolve:null,
                reject: null,
                errors:[],
            }
        },
        computed:{
            availableSizes(){
                var arr = [];
                if(this.$product.smakeVariants){
                    for (var i in this.$product.smakeVariants){
                        this.$product.smakeVariants[i].sizes.forEach(item => {
                            if(!arr.find(x => x == item)) arr.push(item);
                        })
                    }
                }
                var order = ['XS','S','SM','M','MD','L','LG','XL','1XL','XXL','2XL','2X','XXXL','3XL','3X','XXXXL','4XL', '4X','XXXXXL','5XL','5X','XXXXXXL','6XL','6X'];
                arr = arr.sort(function (a, b) {
                    var aSize = a.toUpperCase(), bSize = b.toUpperCase();
                    return order.indexOf(aSize) - order.indexOf(bSize);
                });
                return arr;
            },
            website(){
                return this.$store.getters.activeWebsite;
            },
        },
        created() {
            Vue.prototype.$variants = this;
        },
        methods:{
            toggle(type, item){
                var index = 0;
                if((index = this.array[type].findIndex(x => x == item)) == -1) this.array[type].push(item);
                else this.array[type].splice(index, 1);
            },
            addAttribute(){
                this.edit.attributes.push({
                    custom:true
                })
            },
            selectColor(color){
                var index = this.edit.attributes.findIndex(x => x.name == 'Color');
                if(index != -1){
                    this.edit.attributes[index].value = color.color;
                }else{
                    this.edit.attributes.push({
                        name: 'Color',
                        value: color.color,
                        custom:false,
                        type: 'color'
                    })
                }
                this.selectedColor = color;
                this.selectedColor.sizes = this.orderSizes(this.selectedColor.sizes);
            },
            selectSize(size){
                var index = this.edit.attributes.findIndex(x => x.name == 'Size');
                if(index != -1){
                    this.edit.attributes[index].value = size;
                }else{
                    this.edit.attributes.push({
                        name: 'Size',
                        value: size,
                        custom:false,
                        type: 'text'
                    })
                }
            },
            getColorByName(name){
                return getColorByName(name);
            },
            close(data){
                if(!data){
                    this.show = false;
                    if(typeof this.reject == 'function'){
                        this.reject;
                        this.edit = null;
                        this.resolve = null;
                    }
                }
            },
            saveGroup(){
                this.errors = [];
                if(this.array.colors.length == 0 || this.array.sizes.length == 0){
                    this.errors.push('You must select sizes and colors');
                    return null;
                }
                var arr = [];
                var smakeData = this.$product.product.smake.data.variants;
                this.array.sizes.forEach(size => {
                    this.array.colors.forEach(color => {
                        var finded = smakeData.find(x => {
                            var check = false, colorFound = false;
                            x.attributes.forEach(at => {
                                if(at.name == 'color' && at.value == color) colorFound = true
                            })

                            if(colorFound){
                                x.attributes.forEach(at => {
                                    if(at.name == 'size' && at.value == size) check = true
                                })
                            }

                            return check;
                        })
                        var el = {size: size, color:color};
                        if(this.$product.product.variantsToDIsplay.indexOf(color)<0) this.$product.product.variantsToDIsplay.push(color);
                        if(finded && finded.images) el.images = finded.images;
                        if(finded && finded.total) el.price = finded.total;
                        arr.push(el);
                    })
                })
                this.resolve(arr);
                this.show = false;
                this.edit = null;
            },
            save(){
                this.errors = [];
                if(!this.edit.attributes.find(x => x.name == 'Color'  && x.value != null && x.value != '')) this.errors.push('You must select color first');
                if(!this.edit.attributes.find(x => x.name == 'Size' && x.value != null && x.value != '')) this.errors.push('You must select size first');
                if(this.$refs.attribute_form.my_validate() && this.errors.length == 0){
                    var color = this.edit.attributes.find(x => x.name == 'Color').value;
                    var size = this.edit.attributes.find(x => x.name == 'Size').value;
                    var smakeData = this.$product.product.smake.data.variants;
                    var finded = smakeData.find(x => {
                        return x.attributes.find(y => y.name == 'color' && y.value == color) && x.attributes.find(y => y.name == 'size' && y.value == size);
                    })
                    if(!finded){
                        this.errors.push('Smake variant not found');
                        return null;
                    } else{
                        this.edit.smake_id = finded.id;
                    }
                    if(finded.images && (!this.edit.photos || this.edit.photos.length == 0)){
                        this.edit.photos = finded.images.map((item) => {
                            return item.image;
                        })
                    }
                    if(finded && finded.total){
                        this.edit.price = finded.total;
                    }
                    this.resolve(this.edit);
                    this.edit = null;
                    this.selectedColor = null;
                }else{
                    setTimeout(() => {
                        this.errors = [];
                    }, 5000)
                }
            },
            getAutocomplete(){
                getAttributes(this.website.id).then(response => {

                })
            },
            orderSizes(sizes){
                var order = ['xs', 's', 'm', 'l', 'xl', '2xl', '3xl', '4xl', '5xl'];
                sizes = sizes.sort(function (a, b) {
                    var aSize = a.toLowerCase(), bSize = b.toLowerCase();
                    return order.indexOf(aSize) - order.indexOf(bSize);
                });
                return sizes;
            },
            addVariant(variant = null, group = false){
                return new Promise((resolve, reject) => {
                    this.getAutocomplete();
                    this.resolve = resolve;
                    this.reject = reject;
                    this.group = group;
                    if(this.group){
                        this.array = {
                            sizes:Object.assign([], this.availableSizes),
                            colors:[]
                        };
                    }
                    if(!variant){
                        this.$set(this, 'edit', {show: true, attributes:[]});
                        this.selectedColor = null;
                    }else{
                        variant.show = true;
                        var color_var = variant.attributes.find(x => x.name =='Color');
                        for(var i in this.$product.smakeVariants){
                            if(this.$product.smakeVariants[i].color == color_var.value){
                                this.selectedColor = this.$product.smakeVariants[i];
                                this.selectedColor.sizes = this.orderSizes(this.selectedColor.sizes);
                            }
                        }
                        this.$set(this, 'edit', variant);

                    }
                });
            },
        },
    }
</script>
